/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
import keyMirror from 'external/keymirror';

export const ActionTypes = keyMirror({
    SELECTED_FLIWAS_ORGANIZATION_DETAILS_CONFIG_ID: null
});

export const DataNames = keyMirror({
    SELECTED_FLIWAS_ORGANIZATION: null
});

export const ClassNames = keyMirror({
    Organization: null,
    Group: null
});

export const AdministrativeRank = {
    RP: 3,
    DISTRICT: 4,
    COMMUNE: 6
};

export const STORE_KEY_CURRENT_ORGANIZATION = 'currentOrganization';




// WEBPACK FOOTER //
// ./js/constants/Constants.js